module.exports = __webpack_public_path__ + "e9257dfc.png";